<template>
  <Transition name="fade">
    <div v-if="expandToggle" class="fixed right-4 bottom-4 z-50">
      <div
        data-cy="language-switch-expanded"
        class="locale-changer right-4 bottom-4 font-bold text-lg bg-grey-50 z-40 rounded-sm py-3 px-2 overflow-hidden shadow-lg w-auto"
      >
        <div
          class="flex items-center cursor-pointer hover:bg-grey-100 p-2 rounded-md gap-2"
          v-for="(locale, index) in supportedLocales"
          :key="`locale-${locale}`"
          :data-cy="`language-option-${locale}`"
          :class="index == 0 ? 'mb-3' : ''"
          @click="switchLanguage(locale)"
        >
          <img :src="localeData[locale].img" :alt="localeData[locale].label" class="w-8 h-6 mr-1" />
          <label class="ml-2 cursor-pointer text-lg">{{ localeData[locale].label }}</label>
        </div>
      </div>
    </div>
    <div v-else class="fixed right-4 z-50 bottom-4">
      <div
        data-cy="language-switch"
        class="font-bold text-lg bg-grey-50 rounded-xs w-12 h-12 overflow-hidden shadow-lg flex items-center justify-center cursor-pointer"
        @click="emit('toggleExpand', true)"
      >
        <img
          data-cy="flag"
          :src="localeData[currentLocale].img"
          :alt="localeData[currentLocale].label"
          class="w-8 h-6"
        />
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SupportedLanguages } from '@/i18n'

defineProps<{
  expandToggle: boolean
}>()

const emit = defineEmits<{
  toggleExpand: [value: boolean]
}>()

const { locale, availableLocales } = useI18n()

const localeData: Record<SupportedLanguages, { img: string; label: string }> = {
  en: {
    img: '/img/lang/en.png',
    label: 'English',
  },
  de: {
    img: '/img/lang/de.png',
    label: 'Deutsch',
  },
}

// vue-i18n hands these over as plain strings; the app only ever registers
// the locales `SupportedLanguages` lists.
const supportedLocales = computed(() => availableLocales as SupportedLanguages[])

const currentLocale = computed(() => locale.value as SupportedLanguages)

function switchLanguage(newLocale: string) {
  locale.value = newLocale
  localStorage.setItem('LANG', newLocale)
  emit('toggleExpand', false)
}
</script>
